import React from 'react';

const Tooltip = ({
  text,
  children,
}: {
  text: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="relative flex justify-center group">
      {children}
      <div className="absolute bottom-full mb-2 w-max px-3 py-1 text-white text-sm bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        {text}
        <div className="absolute left-1/2 transform -translate-x-1/2 top-full border-8 border-transparent border-t-gray-800"></div>
      </div>
    </div>
  );
};
export default Tooltip;
